import { useMemo } from 'react'

import { useLocation } from 'react-router'

import { hitParametersUrl } from 'common/constants'

export const useHitQueryParams = (): number => {
  const { search } = useLocation()
  const hitId = new URLSearchParams(search).get(hitParametersUrl)

  return useMemo(() => Number(hitId), [hitId])
}
